import * as FileSaver from 'file-saver';

export function textToFile(text: string, fileName: string) {
  const blob = new Blob([text], { type: 'text/plain' });
  FileSaver.saveAs(blob, fileName);
}
